import { render, staticRenderFns } from "./AppFoot.vue?vue&type=template&id=e8feccbe"
import script from "./AppFoot.vue?vue&type=script&lang=js"
export * from "./AppFoot.vue?vue&type=script&lang=js"
import style0 from "./AppFoot.vue?vue&type=style&index=0&id=e8feccbe&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports